import apiPaths from '../api-paths';

const baseUrl = `${ apiPaths.CRM }/template-basic-price-list`;

export default {
  index() {
    return axios.get(`${ baseUrl }`);
  },
  list(params = {}) {
    return axios.get(`${ baseUrl }`,
      {
        params: {
          ...params,
          list: true,
        },
      },
    );
  },
  show({ id }) {
    return axios.get(`${ baseUrl }/${ id }`);
  },
  store({ data }) {
    return axios.post(`${ baseUrl }`, { templatepricelist: data });
  },
  update({ data }) {
    return axios.put(`${ baseUrl }/${ data.id }`, { templatepricelist: data });
  },

  delete({ id }) {
    return axios.delete(`${ baseUrl }/${ id }`);
  },

  recalculatePriceList(data) {
    return axios.post(`${ baseUrl }/recalculate`, data);
  },

  calculatePriceList({ templatepricelist }) {
    return axios.post(`${ baseUrl }/calculate`, { templatepricelist });
  },

  calculateItem({ item }) {
    return axios.post(`${ baseUrl }/calculateItem`, { item });
  },

  copyTemplateToPriceList({ id }) {
    return axios.post(`${ baseUrl }/copy-template-to-price-list`, { id });
  },

  copyToTemplate({ sourceId, name }) {
    return axios.post(`${ baseUrl }/copy-template-to-template`, { id: sourceId, data: { name } });
  },

  copyDefaultFromAdmin() {
    return axios.post(`${ baseUrl }/copy-default-from-admin`, {});
  },
};
